import React from 'react';
import { IconDownArrow } from '../icons/Icons';
const NextButton = ({ text, goToNextAccordion }) => {
    return (React.createElement("button", { className: "next-button", onClick: goToNextAccordion },
        React.createElement("span", null, text),
        React.createElement(IconDownArrow, null)));
};
export default NextButton;
